import axios from "axios"
import { LOCAL_TOKEN } from "../utils/storage"

export const sendTestMeasure = ({ idMeasurement, idMeasure, params = {} }) => {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasure ||
      idMeasurement}/wizard/preview`,
    data: params,
  })
}
